import { NotificationChannel } from '@tribeplatform/gql-client/types'
import { useDomain } from '@tribeplatform/react-components/common/hooks'
import { useRouter } from '@tribeplatform/react-sdk'
import {
  useAuthToken,
  useUpdateMemberNetworkNotificationSettings,
} from '@tribeplatform/react-sdk/hooks'

export const useLogout = () => {
  const { redirect } = useRouter()
  const { subfolder } = useDomain()
  const { mutateAsync: updateMemberNetworkNotificationSettings } =
    useUpdateMemberNetworkNotificationSettings()
  const {
    data: { network, accessToken },
  } = useAuthToken()

  const apiLogout = async () => {
    const { default: axios } = await import('axios')
    return axios.get(`${subfolder || ''}/api/auth/logout`, {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    })
  }

  const logout = async () => {
    try {
      await Promise.allSettled([
        apiLogout(),
        updateMemberNetworkNotificationSettings({
          channel: NotificationChannel.DESKTOP,
          input: {
            enabled: false,
          },
        }),
      ])
    } catch (e) {
      console.warn('Could not logout the user')
    }
    redirect(network.activeSso?.logoutUrl || '/auth/login?auto_login=false')
  }

  return {
    logout,
  }
}
